"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBoolean = void 0;
const assertString_1 = require("./util/assertString");
function toBoolean(str, strict) {
    (0, assertString_1.assertString)(str);
    if (strict) {
        return str === '1' || /^true$/i.test(str);
    }
    return str !== '0' && !/^false$/i.test(str) && str !== '';
}
exports.toBoolean = toBoolean;
